import {
  BooleanField,
  Create,
  Datagrid,
  EmailField,
  FunctionField,
  List,
  Pagination,
  PasswordInput,
  SimpleForm,
  TextInput,
  TopToolbar,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { Box, Button, Card, CardContent, CardHeader } from "@mui/material";
import CloseIcon from "@mui/icons-material/RemoveCircle";
import { userApi } from "../providers/env";
import { useNavigate } from "react-router";
import { Add } from "@mui/icons-material";

const DeactivateButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleDeactivate = async (user: any) => {
    try {
      await userApi.toggleUserActive({ userId: user.id });
      notify("Deactivate successfully", { type: "success" });
      refresh();
    } catch (error: any) {
      notify(error.message || "Error occurred", { type: "error" });
    }
  };

  if (!record) return null;

  return (
    <Button
      variant="outlined"
      startIcon={<CloseIcon />}
      onClick={() => handleDeactivate(record)}
      sx={{
        borderColor: "error.main",
        color: "#000",
        "&:hover": {
          backgroundColor: "error.main",
          color: "white",
        },
      }}
    >
      Deactivate
    </Button>
  );
};
const VariablePagination = (props: any) => (
  <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />
);

const ActionsField = ({ record }: any) => {
  const getPermissions = (): any => {
    try {
      const item = localStorage.getItem("permissions");
      return item ? JSON.parse(item) : [];
    } catch {
      return [];
    }
  };

  const permissions = getPermissions();
  if (!record) return null;

  if (permissions?.id === record.id) {
    return null;
  }

  return (
    <Box>
      <DeactivateButton />
    </Box>
  );
};
const ListActions = () => {
  const navigate = useNavigate();
  return (
    <TopToolbar>
      <Button variant="contained" onClick={() => navigate(`/users/create`)}>
        <Add fontSize="small" sx={{ mr: 0.5 }} /> Create
      </Button>
    </TopToolbar>
  );
};
export const UserList = (props: any) => {
  return (
    <>
      <List
        {...props}
        component="div"
        perPage={25}
        pagination={<VariablePagination />}
        actions={<ListActions />}
      >
        <Card sx={{ m: 2 }} className="user-component">
          <CardHeader title="Users" />
          <CardContent>
            <Datagrid bulkActionButtons={false}>
              <EmailField source="email" />
              <BooleanField source="is_active" />
              <BooleanField source="is_superuser" label="Is superadmin" />
              <FunctionField
                label="Actions"
                render={(record: any) => <ActionsField record={record} />}
                cellClassName="column-actions"
              />
            </Datagrid>
          </CardContent>
        </Card>
      </List>
    </>
  );
};

export const UserCreate = (props: any) => (
  <Create {...props}>
    <SimpleForm defaultValues={{ is_superuser: false }}>
      <TextInput source="email" fullWidth />
      <PasswordInput source="password" fullWidth />
    </SimpleForm>
  </Create>
);
